import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import fire from "./Firebase";
import "../App.css";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as htmlToImage from "html-to-image";

function Try6() {
  document.title = "HR School-Single Certificate";

  // const conponentPDF = useRef();
  const [usercertificate6, setusercertificate6] = useState([]);
  const domEl = useRef({});
  const downloadImage = async () => {
    const dataUrl = await htmlToImage.toJpeg(domEl.current);

    // download image
    const link = document.createElement("a");
    link.download = "html-to-img.jpeg";
    link.href = dataUrl;
    link.click();
  };
  useEffect(() => {
    fire
      .child(`certificates/${sessionStorage.getItem("lastname6")}`)
      .on("value", (sna) => {
        setusercertificate6([sna.val()]);
      });
  }, []);
  // const generatePDF = useReactToPrint({
  //   content: () => conponentPDF.current,
  //   documentTitle: "Userdata",
  //   onAfterPrint: () => toast("Data saved in PDF"),
  // });
  return (
    <div>
      <Header />
      <div>
        {usercertificate6.map((datas6) => {
          return (
            <>
              <div id="certificatetemp6" ref={domEl} style={{textTransform:"uppercase"}}>
                <div>
                  <div
                  // style={{
                  //   height: "100%",
                  //   width: "100%",
                  //   padding: "10px",
                  //   backgroundColor: "lightseagreen",
                  // }}
                  >
                    <div>
                      <div>
                        <div className="cert-logo">
                          <div className="cert-logo-name">
                            HR School
                            <br />
                          </div>
                        </div>
                      </div>
                      <div className="cert-title">
                        CERTIFICATE OF COMPLETION
                      </div>
                      <div className="cert-no">
                        CERTIFIED {datas6.Field} SPECIALIST
                      </div>
                      <div className="cert-content">
                        <div className="cert-label">
                          THIS IS TO CERTIFY THAT
                        </div>{" "}
                        <br />
                        <div className="cert-user">
                          <div className="cert-user-name">
                            NAME :- {datas6.Gender} {datas6.Name}
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            FATHER NAME :- {datas6.Father}
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            COURSE DURATION :- {datas6.Course} MONTHS
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            COURSE NAME :- {datas6.Coursename}
                          </div>{" "}
                          <br />
                        </div>
                        <div className="cert-achievement">
                          THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                          TAKE IT AWAY FROM YOU.
                        </div>{" "}
                        <br />
                        <br />
                        <div className="cert-signature">
                          <div>
                            HAS SUCCESSFULLY COMPLETED THE {datas6.Coursename}{" "}
                            COURSE WITH HR SCHOOL
                          </div>{" "}
                          <br />
                          <div className="cert-signature-sign"></div>
                          <div>
                            <div style={{ fontWeight: "bold" }}>
                              WITH SCORE OF {datas6.grade}
                            </div>{" "}
                            <br />
                            <div style={{ fontWeight: "bold" }}>Dated</div>{" "}
                            <br />
                          </div>
                          <div>
                            START DATE :- {datas6.startdate}/{datas6.startmonth}
                            /{datas6.startyear}
                          </div>
                          <br />
                          <div>
                            END DATE :-{datas6.enddate}/{datas6.endmonth}/
                            {datas6.endyear}
                          </div>
                        </div>
                      </div>

                      <div style={{ textAlign: "center" }}>
                        www.hrschool.com
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
      <center>
        {" "}
        <br />
        {/* <button onClick={() => generatePDF()}>Convert In PDF</button> */}
        <button onClick={downloadImage} style={{ color: "black" }}>
          Download Image
        </button>
      </center>
    </div>
  );
}

export default Try6;
